import * as React from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import PopSnackbar from "../../components/snackbar/index.js";
import {
  EditPartnerDetails,
  GetPartnerDetails,
} from "../../services/partners.js";

const styles = {
  select: {
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#f9f9f9",
    },
    "& .MuiInputLabel-root": { color: "#555" },
    "&.Mui-disabled .MuiOutlinedInput-root": { backgroundColor: "#f0f0f0" },
  },
};

export default function EditPartner() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [partner, setPartner] = useState(null);

  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [network, setNetwork] = useState("");
  const [logo, setLogo] = useState("");
  const [toastStatus, setToastStatus] = useState(false);
  const [toastDescription, setToastDescription] = useState("");

  React.useEffect(() => {
    fetchPartner();
  }, [id]);

  const fetchPartner = async () => {
    const res = await GetPartnerDetails(id);
    if (res.status === "OK") {
      const data = res.data;
      setPartner(data);
      setName(data.name || "");
      setNetwork(data.network || "");
      setLogo(data.logo || "");
    } else {
      handleStatus(
        "Nu s-a putut incarca partenerul.",
        setToastStatus,
        setToastDescription
      );
    }
  };

  const handleFileRead = async (event) => {
    return await convertBase64(event);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (file) fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleButtonClick = () => {
    document.querySelector("#file-input").click();
  };

  const handleStatus = (description, setStatus, setDescription) => {
    setStatus(true);
    setDescription(description);
    setTimeout(() => {
      setStatus(false);
      setDescription("");
    }, 5000);
  };

  const submitForm = async () => {
    let finalLogo = logo;

    if (file) {
      finalLogo = await handleFileRead(file);
    }

    if (!network) {
      handleStatus("Selecteaza o retea", setToastStatus, setToastDescription);
      return;
    }

    if (name.length < 4) {
      handleStatus(
        "Numele trebuie sa aiba cel putin 4 caractere",
        setToastStatus,
        setToastDescription
      );
      return;
    }

    const updatedData = {
      name,
      logo: finalLogo,
      network,
    };

    try {
      setLoading(true);
      const res = await EditPartnerDetails(id, JSON.stringify(updatedData));

      if (res.error) {
        handleStatus(res.error, setToastStatus, setToastDescription);
      } else if (res.status === "OK") {
        navigate("/partners");
      }
    } catch (err) {
      handleStatus("Something went wrong", setToastStatus, setToastDescription);
    } finally {
      setLoading(false);
    }
  };

  if (!partner) return <CircularProgress />;

  return (
    <div>
      {toastStatus && <PopSnackbar message={toastDescription} />}

      <div
        style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}
      >
        <div className="upload-container">
          <div className="input-circle" onClick={handleButtonClick}>
            <input
              type="file"
              id="file-input"
              name="photo"
              className="input-field"
              accept="image/*"
              onChange={(event) => {
                setFile(event.target.files[0]);
              }}
            />
            <div className="inner-circle">
              {file ? (
                <div className="inner-circle-img-container">
                  <img
                    src={URL.createObjectURL(file)}
                    alt="preview"
                    className="inner-circle-img"
                  />
                  <div className="add-photo-overlay">
                    <AddAPhotoIcon />
                    <span className="upload-text">Update photo</span>
                  </div>
                </div>
              ) : (
                <>
                  <img
                    src={logo || "https://placehold.co/200x200"}
                    alt="current"
                    className="inner-circle-img"
                  />
                  <div className="add-photo-overlay">
                    <AddAPhotoIcon />
                    <span className="upload-text">Update photo</span>
                  </div>
                </>
              )}
            </div>
          </div>

          <span className="upload-text-2">
            Permis *.jpeg, *.jpg, *.png
            <br />
            marime maxima of 3.1 MB
          </span>

          <FormControl style={{ width: "50%" }}>
            <InputLabel id="network-label">Retea</InputLabel>
            <Select
              sx={styles.select}
              labelId="network-label"
              id="network-select"
              value={network}
              label="Rețea"
              onChange={(e) => setNetwork(e.target.value)}
            >
              <MenuItem value="Healthcare">Healthcare</MenuItem>
              <MenuItem value="InfoSanatate">InfoSanatate</MenuItem>
            </Select>
          </FormControl>

          <TextField
            sx={styles.select}
            label="Nume partener"
            variant="outlined"
            style={{ marginBlock: 20, width: "50%" }}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <button
            style={{ width: "50%" }}
            onClick={submitForm}
            disabled={loading}
            className="add-video-button"
          >
            {loading ? "Se salveaza..." : "Salveaza modificarile"}
          </button>
        </div>
      </div>
    </div>
  );
}
